
class DateHelper
{
    gwPattern = RegExp('[1|2][0|1|9][0-9][0-9][0-1][0-9][0-3][0-9]');

    inputPattern = RegExp('[1|2][0|1|9][0-9][0-9]-[0-1][0-9]-[0-3][0-9]');

    frPattern = RegExp('[0-3][0-9]/[0-1][0-9]/[1|2][0|1|9][0-9][0-9]');

    usPattern = RegExp('/[1|2][0|1|9][0-9][0-9]/[0-1][0-9]/[0-3][0-9]');

    /**
     * convert a date from GW (yyyyMMdd) to React form (yyyy-MM-dd)
     */
    GWDateToInput(date){
        if(!this.gwPattern.test(date)) return false;

        return date.substr(0,4)+'-'+date.substr(4,2)+'-'+date.substr(6,2);
    }

    /**
     * convert a date from React form (yyyy-MM-dd) to GW (yyyyMMdd)
     */
    InputDateToGW(date){
        if(!this.inputPattern.test(date)) return false;
        return date.split('-').join('');
    }

    /**
     * convert a date from React form (yyyy-MM-dd) to FR date (dd/MM/yyyy)
     */
    InputDateToFr(date){
        if(!this.inputPattern.test(date)) return false;
        return date.split('-').reverse().join('/');
    }

    /**
     * convert a date from React form (yyyy/MM/dd) to FR date (dd/MM/yyyy)
     */
    UsToFr(date){
        if(!this.usPattern.test(date)) return false;
        return date.split('/').reverse().join('/');
    }

    /**
     * convert input date string into js datetime
     */
    InputToJSDate(date){
        if(!this.inputPattern.test(date)) return false;
        return new Date(date.substr(0,4),date.substr(5,2)-1,date.substr(8,2),0,0,0);
    }

    /**
     * convert js datetime to yyyy-MM-dd
     */
    JSDateToInput(date){
        return date.getFullYear()+'-'+this.pad(date.getMonth() + 1)+'-'+this.pad(date.getDate());
    }

    /**
     * compare 2 date from input
     */
    isInputDateSup(date1Str,date2Str){
        if(date1Str===undefined || date1Str==='' || date2Str===undefined ||date2Str==='') return true;
        if(!this.inputPattern.test(date1Str)||!this.inputPattern.test(date2Str)) return false;
        return this.InputToJSDate(date1Str)>=this.InputToJSDate(date2Str);
    }

    /**
     * strict compare 2 date from input
     */
    isInputDateSupStrict(date1Str,date2Str){
        if(date1Str===undefined || date1Str==='' || date2Str===undefined ||date2Str==='') return true;
        if(!this.inputPattern.test(date1Str)||!this.inputPattern.test(date2Str)) return false;
        return this.InputToJSDate(date1Str)>this.InputToJSDate(date2Str);
    }

    /**
     * return the number of days between 2 dates
     */
    getNbDays(dateStart,dateEnd){
        // prevent result if data are not set
        if(dateStart==='' || dateEnd==='') return null;
        if(!this.inputPattern.test(dateStart)||!this.inputPattern.test(dateEnd)) return false;

        const oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
        const start = this.InputToJSDate(dateStart)
        const end = this.InputToJSDate(dateEnd)
        return Math.round(Math.abs((end.getTime() - start.getTime())/(oneDay)));
    }

    /**
     * Get current month as number (from 0 to 11) : January is 0, February is 1, and so on.
     * @ see https://www.w3schools.com/jsref/jsref_getmonth.asp
     */
    getCurrentMonth = () => {
        const d = new Date();
        return d.getMonth();
    }

    /**
     * Get current year as number AAAA
     * @ see https://www.w3schools.com/jsref/jsref_getfullyear.asp
     */
    getCurrentYear = () => {
        const d = new Date();
        return d.getFullYear();
    }

    /**
     * get month from yyyy-MM-dd date
     */
    getInputMonth = (inputDate) => {
        if(!this.inputPattern.test(inputDate)) return false;
        return inputDate.substr(5,2)-1;
    }

    /**
     * get year from yyyy-MM-dd date
     */
    getInputYear = (inputDate) => {
        if(!this.inputPattern.test(inputDate)) return false;
        return inputDate.substr(0,4);
    }

    /**
     * get current date formated yyyy-MM-ddTHH:MM:SS.000Z
     */
    getDateMod = (d = new Date()) => {
        return d.getFullYear()+'-'+this.pad(d.getMonth())+'-'+this.pad(d.getDate())+'T'+this.pad(d.getHours())+':'+this.pad(d.getMinutes())+':'+this.pad(d.getSeconds())+'.000Z';
    }

    /**
     * return number x to 0x
     */
    pad = ( value, nb=2 ) => {
        return ( '0'+value ).slice( nb*-1 );
    }

    /**
     * sort date when DD/MM/AAAA HHhMM
     */
    sortDateWithHour = (a,b) => {
        var tmp1 = a.split(' ');
        var date1 = tmp1[0].split('/').reverse().join('')+tmp1[1].replace('h','');

        var tmp2  = b.split(' ');
        var date2 = tmp2[0].split('/').reverse().join('')+tmp2[1].replace('h','');

        return date1-date2;
    }

    /**
     * sort date when DD/MM/AAAA
     */
    sortDate = (a,b) => (a.split('/').reverse().join(''))-(b.split('/').reverse().join(''))

}

/**********
 * EXPORT *
 **********/

export default new DateHelper();